// @flow
import Message, { Messages } from "./Message";

export { Messages, Message };



// WEBPACK FOOTER //
// ./src/components/Firebase/index.js